import { Paper, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface ChartWrapperCardProps {
  title: string;
  children?: React.ReactNode;
}

export function ChartWrapperCard({ title, children }: ChartWrapperCardProps) {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Paper
      elevation={enableDarkTheme ? 2 : 1}
      sx={{
        textAlign: 'left',
        m: 2.5,
        p: 2,
        borderRadius: '8px',
        backgroundColor: enableDarkTheme ? palette.boxBackground : '#fff',
        border: `1px solid ${
          enableDarkTheme ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.05)'
        }`,
        boxShadow: enableDarkTheme
          ? '0 4px 20px rgba(0, 0, 0, 0.2)'
          : '0 4px 20px rgba(0, 0, 0, 0.05)',
        color: enableDarkTheme ? '#fff' : '#000',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          fontSize: '1rem',
          fontWeight: 600,
        }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
}

export default ChartWrapperCard;
